/**
 * @fileoverview POSTWS handler for the
 * "/:app_group_id/generative_ai/brand_guidelines_test_generation" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAppGroupIdBrandGuidelinesTestGeneration } from "./constants";
import type {
  PostwsGenerativeAiAppGroupIdBrandGuidelinesTestGenerationPayload,
  PostwsGenerativeAiAppGroupIdBrandGuidelinesTestGenerationProps,
} from "./types";
import { isPostwsGenerativeAiAppGroupIdBrandGuidelinesTestGenerationResult } from "./validators";

export const postwsGenerativeAiAppGroupIdBrandGuidelinesTestGeneration = reactQueryPostWebsocketAdapter(
  generativeAiAppGroupIdBrandGuidelinesTestGeneration,
  async (
    signal,
    {
      appGroupId,
      copy,
      languageCode,
      lengthType,
      messageType,
      temporaryGuideline,
      jobToken,
    }: PostwsGenerativeAiAppGroupIdBrandGuidelinesTestGenerationProps
  ): Promise<{}> => {
    const payload: PostwsGenerativeAiAppGroupIdBrandGuidelinesTestGenerationPayload = {
      job_token: jobToken,
      copy,
      language_code: languageCode,
      length_type: lengthType,
      message_type: messageType,
      temporary_guideline: temporaryGuideline,
    };

    return await fetch(
      `/${appGroupId}/generative_ai/brand_guidelines_test_generation`,
      "POST",
      payload,
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isPostwsGenerativeAiAppGroupIdBrandGuidelinesTestGenerationResult
);
